module.exports = __webpack_public_path__ + "static/link-findability-do-170f1221a39806252bc39d0fa9377b09.png";